import React from "react";
import SectionHeading from "../SectionHeading";
import { useTranslation } from "react-i18next";

function GetInTouch() {
  const { t } = useTranslation();
  const contactData = [
    {
      country: "Bosnia and Herzegovina",
      university: "Ministry of Human Rights and Refugees",
      email: "kemo.sarac@mhrr.gov.ba",
      phone: "38733202600",
      footer: "Kemo SARAC",
      description: "Assistant Minister for Human Rights, Ministry for Human Rights and Refugees of Bosnia and Herzegovina",
    },
    {
      country: "Montenegro",
      university: "Ministry of Human and Minority Rights",
      email: "sokolj.beganaj@mmp.gov.me",
      footer: "Sokolj BEGANAJ",
      description: "Head of the Department for the Promotion and Protection of the Rights of Roma and Egyptians",
    },
    {
      country: "North Macedonia",
      university: "Government of North Macedonia",
      email: "shaban.saliu@gs.gov.mk",
      footer: "Shaban SALIU",
      description: "Minister without portfolio responsible for implementation of the Strategy for Inclusion of Roma",
    },
    {
      country: "North Macedonia",
      university: "Ministry of Labour and Social Policy",
      email: "mkamberi@mtsp.gov.mk",
      footer: "Mabera KAMBERI ",
      description: "Head of Department for Coordination and Technical Assistant to the Minister",
    },
    {
      country: "Serbia",
      university: "Ministry of Human and Minority Rights and Social Dialogue",
      email: "kabinet@minljmpdd.gov.rs",
      phone: "381 11 31 14 528",
      // footer: "Tomislav ZIGMANOV",
      footer: "Demo Berisa",
      description: "Minister",
    },
    {
      country: "Serbia",
      university: "Ministry for Human and Minority Rights and Social Dialog",
      email: "sofija.osmanovic@minljmpdd.gov.rs",
      phone: "381 11 22 50 617 | 381 62 595 377",
      footer: "Sofija OSMANOVIC",
      description: "Cheaf of department for for improvement of the position of Roma",
    },
    {
      country: "Kosovo*",
      university: "Office of the Prime Minister",
      email: "Habit.Hajredini@rks-gov.net",
      phone: "37744174282",
      footer: "Habit HAJREDINI",
      description: "Director of the Office for Good Governance, Human Rights, Equal Opportunities and Anti-Discrimination",
    },
    {
      country: "Montenegro",
      university: "",
      email: "mladenka.tesic@eeas.europa.eu",
      phone: "",
      footer: "Mladenka TEŠIĆ",
      description: "EU Delegation to Montenegro",
    },
    {
      country: "Serbia",
      university: "",
      email: "mirjana.maksimovic@eeas.europa.eu",
      phone: "",
      footer: "Mirjana MAKSIMOVIĆ",
      description: "EU Delegation to Serbia",
    },
    {
      country: "Kosovo",
      university: "",
      email: "Pleurat.KURTI@ext.eeas.europa.eu",
      phone: "",
      footer: "Pleurat KURTI",
      description: "EU Office in Kosovo",
    },
    {
      country: "Bosnia and Herzegovina",
      university: "",
      email: "ajsa.adrovic-beslagic@eeas.europa.eu",
      phone: "",
      footer: "Ajsa ADROVIĆ-BEŠLAGIĆ",
      description: "EU Delegation to Bosnia and Herzegovina",
    },
    {
      country: "North Macedonia",
      university: "",
      email: "nafi.saracini@eeas.europa.eu",
      phone: "",
      footer: "Nafi SARACINI",
      description: "EU Delegation to North Macedonia",
    },
  ];

  return (
    <section className="get-in-touch">
    
      <SectionHeading title={t("contact-us:sub-title","Get in touch with our team")} />
      <div className="row justify-content-center g-md-4 g-3">
        {contactData.map((data, index) => {

          // convert country name like "Serbia" → translation key "country.serbia"
          const countryKey = `country:${data.country?.toLowerCase().replace(/\s+/g, "-")}`;
          const translatedCountry = t(countryKey, data.country); // fallback to original if not found

          return (<div className="col-lg-4 col-sm-6" key={index}>
            <div className="contact-card">
              {/* <div className="info-header">{data.country}</div> */}
              <div className="info-header">{translatedCountry}</div>
              <div className="info-body">
                <h4>{data.university}</h4>
                <div className="contact-info">
                  <div className="info-icon">
                    <img src="/images/svg/mail.svg" className="img-fluid" alt="" />
                  </div>
                  <div>
                    <h5>{t("contact-us:email","Email")}</h5>
                    <p className="f-s-14 mb-0">{data.email}</p>
                  </div>
                </div>
                {data.phone && (
                  <div className="contact-info">
                    <div className="info-icon">
                      <img src="/images/svg/phone.svg" className="img-fluid" alt="" />
                    </div>
                    <div>
                      <h5>{t("contact-us:phone","Phone")}</h5>
                      <p className="f-s-14 mb-0">{data.phone}</p>
                    </div>
                  </div>
                )}
              </div>
              <div className="info-footer">
                <h5>{data.footer}</h5>
                <p>{data.description}</p>
              </div>
            </div>
          </div>
          );
          })}
      </div>
      {/* <div className="contact-line">
        <img src="/images/png/contact-line.png" className="img-fluid w-100 h-100" alt="" />
        <span></span>
      </div> */}
    </section>
  );
}

export default GetInTouch;
